import * as React from 'react';
import {useCallback, useEffect, useRef, useState} from 'react';
//import DownloadIcon from '@material-ui/icons/GetApp';
import {
    //fetchRelatedRecords,
    useNotify,
    useListContext,
} from 'ra-core';
import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
    useMediaQuery
} from "@material-ui/core";
import {fetchBlob, fetchJson as httpClient} from '../../utils/keycloak';
import DownloadIcon from "@material-ui/icons/GetApp";
// import {saveAs} from 'file-saver';
// import moment from "moment";
import config from "../../utils/config";
import CircularProgress from '@mui/material/CircularProgress';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import {useLocale, useTranslate} from "react-admin";
import Asynchronous2 from "../../_common/AsynchronousRequests2";
import {Typography} from "@mui/material";
import {choicesItemCodeInAccountingSystem} from "../../_constants/choices";
import HelpIcon from "@mui/icons-material/Help";
import CropFreeIcon from "@material-ui/icons/CropFree";
import GetAppIcon from "@mui/icons-material/GetApp";
import ClearIcon from "@mui/icons-material/Clear";
// import * as XLSX from "xlsx";

const defaultIcon = <DownloadIcon/>;

const HandlerCreateExcellFile = (props) => {
    const {
        onClick,
        label,
        type,
        icon = false,
    } = props;
    const {
        resource,
        selectedIds,
        // filterValues,
    } = useListContext(props);

    //const exporter = customExporter || exporterFromContext;
    const translate = useTranslate();
    const locale = useLocale();
    const isSmall = useMediaQuery(function (theme) {
        return theme.breakpoints.down('sm'); //xs  sm
    });
    const notify = useNotify();
    const fileInputRef = useRef(null);    // const refresh = useRefresh();

    const [form, setForm] = useState({
        manager_id: null,
        item_code_in_accounting_system: null,
        price_region: null,
        sales_representative_1: null,
        sales_representative_2: null,
        buisness_type: null,
        direction_of_activity: null,
    });

    const [openDialog, setOpenDialog] = useState(false);
    const [myUrl, setMyUrl] = useState(`${config.apiUrl}${'api/get-customer-document'}`);

    const [fileName, setFileName] = useState(null);
    const [file_bin, setFile_bin] = useState(null);
    const [file_base64, setFile_base64] = useState(null);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);


    const [sheetName, setSheetName] = useState('os');

    const handleChange = (event) => {
        setSheetName(event.target.value);
    };
    const getData = async (requestUrl) => {
        try {
            /*const response = await fetch(myUrl, {
                method: 'GET',
                headers: {
                    Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    // Accept: '*!/!*',
                },
            });
            if (!response.ok) {
                throw new Error('Ошибка при загрузке файла');
            }
            const blob = await response.blob();
            saveAs(blob, 'report.xlsx'); // ← сохраняем файл
            return true*/

            const response = await fetchBlob(requestUrl);

            if (response.status >= 200 && response.status <= 300) {
                const blob = await response.blob();

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                const nameFile = 'Customers_data.xlsx'
                a.download = nameFile;
                a.click();
                window.URL.revokeObjectURL(url);
                notify(`Create file ${nameFile}`, {type: 'success', autoHideDuration: 5000,});
            } else {
                notify(`ERROR ${response.status}`, {type: 'error', autoHideDuration: 8000,});
            }
        } catch (err) {
            console.log('err=======>', err.message);
            notify(err.message, {type: 'error', autoHideDuration: 8000});
        } finally {
            //console.log('finally=======>', 'finally');
        }
    }

    /*useEffect(() => {
        if (selectedIds.length > 0) {
            let str = selectedIds.join(',')
            setMyUrl(`${myUrl}?selected_customers=${str}`)
        }
    }, [selectedIds]);// eslint-disable-line*/

    const handleClick = useCallback(
        event => {
            getData();
            if (typeof onClick === 'function') {
                onClick(event);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [notify, onClick, resource, selectedIds]
    );

    const handleChangeSel = (name, val) => {
        setForm(form => ({
            ...form,
            [name]: val,
        }));
    };

    const handleCLickSave = (name, val) => {
        let url = myUrl
        notify(`Create file...`, {type: 'info', autoHideDuration: 6000,});
        setOpenDialog(false)
        if (selectedIds.length > 0) {
            let str = selectedIds.join(',')
            url = `${myUrl}?selected_customers=${str}`
        } else {
            const params = new URLSearchParams();
            if (form.manager?.id) params.append('manager_id', form.manager.id);
            if (form.item_code_in_accounting_system?.id) params.append('item_code_in_accounting_system', form.item_code_in_accounting_system.id);
            if (form.price_region?.id) params.append('price_region_id', form.price_region.id);
            if (form.sales_representative_1?.id) params.append('manager_tp_sng_id', form.sales_representative_1.id);
            if (form.sales_representative_2?.id) params.append('manager_tp_inom_id', form.sales_representative_2.id);
            if (form.buisness_type?.id) params.append('buisness_type_id', form.buisness_type.id);
            if (form.direction_of_activity?.id) params.append('direction_of_activity_id', form.direction_of_activity.id);

            url = `${myUrl}?${params.toString()}`;
        }
        // console.log('myForm======>', form)
        console.log('myUrl======>', url)
        getData((url));
    };

    const onFileChangeJson = async (event) => {
        const file = event.target.files[0];
        if (!file) {
            setFileName(null)
            setFile_bin(null)
            setFile_base64(null)
            return;
        }

        event.target.value = null;
        setError(null)
        setFileName(file?.name ? file.name : null)

        const reader = new FileReader();
        reader.onload = function () {
            const base64String = reader.result; // строка вида data:application/...;base64,...
            // console.log('Base64:', base64String);
            setFile_base64(base64String)
            // Если нужно только base64 без data:...;base64, префикса:
            // const cleanBase64 = base64String.split(',')[1];
            // console.log('Base64 (без префикса):', cleanBase64);
        };
        reader.onerror = function (error) {
            console.error('Ошибка при чтении файла:', error);
        };

        reader.readAsDataURL(file); // читаем файл как base64 с data:... префиксом

        setFile_bin(file)
    }

    const uploadFile = async (event) => {
        setLoading(true)
        setError(null)
        const formData = new FormData();
        formData.append('file', file_bin); // 👈 backend должен ожидать поле "file"

        let url = `${config.apiUrl}${'api/save-customer-document'}?select_sheet_name=${sheetName}`
        let body = formData
        if (sheetName === 'customerProperty') {
            // url = `${config.apiPrices}${'api/pricing/import-customer-properties-from-xlsx'}`
            url = `${config.apiPrices}${'api/pricing/import-customer-properties-from-base64'}`
            // console.log('result_base64======>', file_base64)
            body = JSON.stringify({
                // filename: fileName,
                base64_string: file_base64, // ⚠️ обычно содержит data:image/... или data:application/...
            })
        }
        try {
            const response = await httpClient(url, {
                method: 'POST',
                body: body,
            })
            const {json} = response || {}
            const {result} = json
            console.log('===!!!===>', response)
            if (response.status >= 200 && response.status <= 300) {
                if (result || sheetName === 'customerProperty') {
                    setFileName(null)
                    notify('✅ Файл успешно загружен', {type: 'success',});
                } else {
                    notify('❌ Ошибка при загрузке файла', {type: 'error',});
                }
            } else {
                notify('❌ Ошибка при загрузке файла', {type: 'error',});
            }

            setLoading(false)
        } catch (err) {
            // console.error(err);
            // alert('❌ Не удалось загрузить файл');
            console.log('err=======>', err.message);
            notify(err.message, {type: 'error',});
            setLoading(false)
            setError(err.message)
        }
    };

    return (
        <>
            <Button
                style={{marginLeft: selectedIds.length > 0 && 24, marginTop: selectedIds.length > 0 && -4}}
                color={"primary"}
                // onClick={handleClick}
                onClick={(event) => {
                    setOpenDialog(true)
                }}
                label={label}
            >
                {icon ? icon : defaultIcon}{label}
            </Button>

            <Dialog
                maxWidth={isSmall ? 'xs' : 'md'}
                open={openDialog}
                onClose={(event) => {
                    setOpenDialog(false)
                    // setError(null)
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {label}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={{width: isSmall ? 400 : 800}}>
                        {type === 'export'
                            ?
                            selectedIds && selectedIds.length > 0
                                ?
                                <span><b>ID</b> = {selectedIds.join(', ')}</span>
                                :
                                <Box fullWidth>
                                    <Typography variant="body" color={'textPrimary'}>
                                        {translate('Select filters (optional)')}
                                    </Typography>
                                    <Typography variant="h6" component="h6" color={'textPrimary'}>
                                        {translate('Customers')}
                                    </Typography>
                                    <Box style={{display: isSmall ? 'grid' : 'flex'}} display="flex" alignItems={"top"}>
                                        <Box flex={3} p={"0.5em"}>
                                            {/*https://dev-services.zenit-auto.com/api/pricing/admin/discount_property_valid_value?discount_property_id=60&limit=25&ordering=-id&skip=0*/}
                                            <Asynchronous2
                                                label={translate('Property of belonging to a region')}
                                                value={form.price_region}
                                                resultStart={{id: -1, name: translate('---None---')}}
                                                setValue={(value) => handleChangeSel('price_region', value)}
                                                domain={config.apiPrices}
                                                url={'api/pricing/admin/discount_property_valid_value'}
                                                filter={'&discount_property_id=60'}
                                                // outputField='id'
                                                searchField={'search'}
                                                getOptionLabel={(option) => `${option['name']}`}
                                                sort={`name`}
                                                highlightBorder={true}
                                                // error={form.customers[index].error?.base_warehouse_main_supplier}
                                            />
                                        </Box>
                                        <Box flex={2} p={"0.5em"}>
                                            <Asynchronous2
                                                label={translate('Code from the accounting system')}
                                                value={form.item_code_in_accounting_system}
                                                setValue={(value) => handleChangeSel('item_code_in_accounting_system', value)}
                                                // domain={'https://overpass-api.de/'}
                                                // url={`api/interpreter?data=${getRequestOverpass('getAreas', '', '', '')}`}
                                                choices={[
                                                    {id: '1', name: translate('Filled')},
                                                    {id: '0', name: translate('Not filled')},
                                                ]}
                                                // outputField='id'
                                                //searchField={'search'}
                                                getOptionLabel={(option) => `${option.name}`}
                                                highlightBorder={true}
                                            />
                                        </Box>
                                    </Box>
                                    <Box style={{display: isSmall ? 'grid' : 'flex'}} display="flex" alignItems={"top"}>
                                        <Box flex={3} p={"0.5em"}>
                                            {/*<Asynchronous2
                                                resultStart={{id: -1, [`name_${locale}`]: translate('---None---')}}
                                                label={translate('Business type')}
                                                value={form.buisness_type}
                                                setValue={(value) => handleChangeSel('buisness_type', value)}
                                                // domain={config.apiPrices}
                                                url={'api/react-admin/main/BusinessType'}
                                                // filter={'&discount_property_id=60'}
                                                // outputField='id'
                                                searchField={'search'}
                                                getOptionLabel={(option) => `${option[`name_${locale}`]}`}
                                                sort={``}
                                                // error={form.customers[index].error?.base_warehouse_main_supplier}
                                            />*/}
                                            <Asynchronous2
                                                label={translate('Field of activity')}
                                                value={form.direction_of_activity}
                                                resultStart={{id: -1, name: translate('---None---')}}
                                                setValue={(value) => handleChangeSel('direction_of_activity', value)}
                                                domain={config.apiPrices}
                                                url={'api/pricing/admin/discount_property_valid_value'}
                                                filter={'&discount_property_id=8632'}
                                                // outputField='id'
                                                searchField={'search'}
                                                getOptionLabel={(option) => `${option['name']}`}
                                                sort={`name`}
                                                highlightBorder={true}
                                                // error={form.customers[index].error?.base_warehouse_main_supplier}
                                            />
                                        </Box>
                                        <Box flex={2} p={"0.5em"}>

                                        </Box>
                                    </Box>


                                    <Typography variant="h6" color={'textPrimary'}>
                                        {translate('Partners')}
                                    </Typography>
                                    <Box style={{display: isSmall ? 'grid' : 'flex'}} display="flex" alignItems={"top"}>
                                        <Box flex={1} p={"0.5em"}>
                                            <Asynchronous2
                                                label={translate('Manager')}
                                                value={form.manager}
                                                resultStart={{id: -1, name: translate('---None---')}}
                                                setValue={(value) => handleChangeSel('manager', value)}
                                                // domain={config.apiPrices}
                                                url={'api/react-admin/main/Manager'}
                                                // outputField='id'
                                                searchField={'search'}
                                                getOptionLabel={(option) => `${option['name']}`}
                                                sort={`name`}
                                                highlightBorder={true}
                                                // error={form.customers[index].error?.base_warehouse_main_supplier}
                                            />
                                        </Box>
                                        <Box flex={1} p={"0.5em"}>
                                            <Asynchronous2
                                                label={translate('Sales representative SNG')}
                                                value={form.sales_representative_1}
                                                resultStart={{id: -1, name: translate('---None---')}}
                                                setValue={(value) => handleChangeSel('sales_representative_1', value)}
                                                // domain={config.apiPrices}
                                                url={'api/react-admin/main/Manager'}
                                                // outputField='id'
                                                searchField={'search'}
                                                getOptionLabel={(option) => `${option['name']}`}
                                                sort={`name`}
                                                highlightBorder={true}
                                                // error={form.customers[index].error?.base_warehouse_main_supplier}
                                            />
                                        </Box>
                                    </Box>
                                    <Box style={{display: isSmall ? 'grid' : 'flex'}} display="flex" alignItems={"top"}>
                                        <Box flex={1} p={"0.5em"}>
                                            <Asynchronous2
                                                label={translate('Sales representative Ino')}
                                                value={form.sales_representative_2}
                                                resultStart={{id: -1, name: translate('---None---')}}
                                                setValue={(value) => handleChangeSel('sales_representative_2', value)}
                                                // domain={config.apiPrices}
                                                url={'api/react-admin/main/Manager'}
                                                // outputField='id'
                                                searchField={'search'}
                                                getOptionLabel={(option) => `${option['name']}`}
                                                sort={`name`}
                                                highlightBorder={true}
                                                // error={form.customers[index].error?.base_warehouse_main_supplier}
                                            />
                                        </Box>
                                        <Box flex={1} p={"0.5em"}>

                                        </Box>
                                    </Box>
                                </Box>
                            :
                            <div>
                                <Box display={'flex'}>
                                    <FormControl component="fieldset">
                                        {/*<FormLabel component="legend">Choose an option</FormLabel>*/}
                                        <RadioGroup value={sheetName} onChange={handleChange}>
                                            <Box display={'flex'} style={{width: isSmall ? 400 : 650}}
                                                 alignItems={"top"}>
                                                <Box flex={1} display={'inline'}>
                                                    <FormControlLabel value="os" control={<Radio/>}
                                                                      label={translate('Update Main Warehouse')}/>
                                                    <FormControlLabel value="ss" control={<Radio/>}
                                                                      label={translate('Update Pickup Warehouses')}/>
                                                    <FormControlLabel value="customerProperty" control={<Radio/>}
                                                                      label={translate('Update counterparty properties')}/>
                                                </Box>
                                                <Box flex={1} display={'inline'}>
                                                    <FormControlLabel value="si" control={<Radio/>}
                                                                      label={translate('Update Exception Warehouses')}/>
                                                    <FormControlLabel value="tpm" control={<Radio/>}
                                                                      label={translate('Update TP Info and Managers')}/>
                                                </Box>
                                            </Box>
                                        </RadioGroup>
                                    </FormControl>
                                </Box>
                                <Box display={'flex'} mt={'2em'}>
                                    <Box>
                                        <input
                                            ref={fileInputRef}
                                            hidden={true}
                                            type="file"
                                            id="fileselect"
                                            name="excell"
                                            onChange={onFileChangeJson}
                                            accept={".xls,.xlsx"}
                                            /*accept={"image/gif, image/jpeg, image/png"}*/
                                        />

                                        <Button
                                            onClick={() => {
                                                document.getElementById('fileselect').click()
                                            }}
                                            color="primary"
                                            startIcon={<CropFreeIcon/>}
                                        >
                                            {translate('Select file')}
                                        </Button>
                                    </Box>
                                    {fileName &&
                                        <Box ml={2}>
                                            <Button
                                                title={fileName}
                                                onClick={(e) => {
                                                    uploadFile()
                                                    // window.location.reload()
                                                }}
                                                color="primary"
                                                startIcon={<GetAppIcon/>}
                                            >
                                                {translate('Download file')}
                                            </Button>
                                        </Box>
                                    }
                                </Box>
                                {fileName
                                    ?
                                    loading
                                        ?
                                        <Box display={'flex'} alignItems={'center'}>
                                            <CircularProgress size={24} style={{marginRight: 16}}/>
                                            <p>⏳ {translate('Uploading file')} {fileName} ...</p>
                                        </Box>
                                        :
                                        <Box display={'flex'} alignItems={'center'}>
                                            <p>{translate('File selected')} {fileName}</p>
                                        </Box>
                                    : null
                                }
                            </div>
                        }
                        {error &&
                            <div>
                                <span style={{fontWeight: 'bold', color: 'red'}}>ERROR: </span>
                                <em style={{marginLeft: 8}}>{error}</em>
                            </div>
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{padding: 24}}>
                    {type === 'export' &&
                        <Box flex={1} textAlign={'start'}>
                            <Button
                                variant="contained"
                                onClick={handleCLickSave}
                                color="primary"
                                // autoFocus
                            >
                                {translate('Export to Excell')}
                            </Button>
                        </Box>
                    }
                    <Box flex={1} textAlign={'end'}>
                        <Button
                            variant="contained"
                            onClick={(event) => {
                                setOpenDialog(false)
                            }}
                            color="error" autoFocus>
                            CLOSE
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
        </>
    )
        ;
};

export default HandlerCreateExcellFile;
